const BUILD_MODE = import.meta.env.MODE;

const libPlugin = {
    install: (app) => {
        app.config.globalProperties.$lib = BUILD_MODE === 'lib';
    },
};

export default libPlugin;
